import React from "react";
import SpotifyEmbed from "./SpotifyEmbed";
import MP3Embed from "./MP3Embed";

export default function MediaAudioItem({ item }) {
  if (item.type.includes("spotify")) {
    return <SpotifyEmbed item={item} />;
  } else if (item.type.includes("mpeg")) {
    return <MP3Embed item={item} />;
  } else if (item.type.includes("custom/iframe")) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <iframe
          src={item?.iframe.src}
          style={{ maxWidth: "100%" }}
          width={item?.iframe.width}
          height={item?.iframe.height}
          title={item?.iframe.title}
        ></iframe>
      </div>
    );
  } else {
    return "";
  }
}
